<template>
  <div>
    <div v-if="step == 'form'">
      <form class="theory__form">
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group" v-bind:class="{ 'has-error': errors.name }">
              <input type="text" class="form-control" placeholder="Ваше имя" v-model="contact.name">
              <p class="help-block" v-if="errors.name">{{ errors.name.join(', ') }} </p>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group" v-bind:class="{ 'has-error': errors.phone }">
              <input type="email" v-model="contact.phone" class="form-control" placeholder="E-mail для отправки">
              <p class="help-block" v-if="errors.phone">{{ errors.phone.join(', ') }}</p>
            </div>
          </div>
        </div>
        <div class="form-group" v-bind:class="{ 'has-error': errors.message }">
          <textarea class="form-control theory__textarea" placeholder="Комментарий (расскажите о ваших целях, опыте и проблемах со здоровьем)" v-model="contact.message"></textarea>
          <p class="help-block" v-if="errors.message">{{ errors.message.join(', ') }} </p>
        </div>
        <div class="form-bottom theory__form-bottom">
          <button class="btn btn-success form-bottom__btn" type="button" v-on:click="sendForm">Отправить</button>
          <div class="form-bottom__text">
            Отправляя сообщение, вы принимаете <a href="/pages/politika-konfidencialnosti/">условия обработки</a> персональных данных
          </div>
        </div>
      </form>
    </div>
    <div v-if="step == 'complete'">
      <p class="text-success">
      Ваше сообщение успешно отправлено! Я свяжусь с Вами в ближайшее время. </p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'


export default {
  name: 'QuestionForm',
  props: ['template'],
  data() {
    return {
      contact: {},
      errors: {},
      step: 'form'
    }
  },
  mounted() {
    axios.get("/contacts/api/consult/").then(response => {this.contact = response.data});
  },
  methods: {
    sendForm: function () {
      axios.put("/contacts/api/consult/", this.contact)
      .then(response => {
        this.contact = response.data;
        this.step = 'complete';
      })
      .catch(error => {
        this.errors = error.response.data;
      });
    }
  }
}
</script>

<style lang="scss">
</style>
